var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconEdit = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 15.226,
  height: 15.437,
  viewBox: "0 0 15.226 15.437",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Group_1240",
  "data-name": "Group 1240",
  transform: "translate(0.153 0.283)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_841",
  "data-name": "Group 841",
  transform: "translate(0)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_834",
  "data-name": "Group 834",
  transform: "translate(1.975 2.636)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_2446",
  "data-name": "Path 2446",
  d: "M662.215,513.75l-3.413-3.413a.117.117,0,0,1,0-.166l6.573-6.573a.118.118,0,0,1,.166,0l3.413,3.413a.118.118,0,0,1,0,.166l-6.574,6.573A.117.117,0,0,1,662.215,513.75Zm-3.165-3.5L662.3,513.5l6.408-6.408-3.247-3.247Z",
  transform: "translate(-658.768 -503.564)",
  fill: "#173a6d",
  stroke: "#173a6d",
  strokeWidth: 0.3
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_835",
  "data-name": "Group 835",
  transform: "translate(8.356 0.802)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_2447",
  "data-name": "Path 2447",
  d: "M682.22,503.992l-3.413-3.413a.117.117,0,0,1,0-.166l2.022-2.023a.117.117,0,0,1,.166,0l3.413,3.413a.117.117,0,0,1,0,.166l-2.023,2.022A.117.117,0,0,1,682.22,503.992Zm-3.164-3.5,3.248,3.247,1.857-1.857-3.247-3.248Z",
  transform: "translate(-678.773 -498.357)",
  fill: "#173a6d",
  stroke: "#173a6d",
  strokeWidth: 0.3
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_836",
  "data-name": "Group 836",
  transform: "translate(10.398)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_2448",
  "data-name": "Path 2448",
  d: "M688.817,500.145l-3.371-3.371a.119.119,0,0,1,0-.169l.287-.287a1.817,1.817,0,0,1,2.493-.136l1.038,1.039a1.992,1.992,0,0,1,.009,2.636l-.288.287A.119.119,0,0,1,688.817,500.145Zm-3.118-3.455,3.2,3.2.2-.2a1.763,1.763,0,0,0-.008-2.3l-1.039-1.039a1.594,1.594,0,0,0-2.155.135Z",
  transform: "translate(-685.411 -495.75)",
  fill: "#173a6d",
  stroke: "#173a6d",
  strokeWidth: 0.3
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_837",
  "data-name": "Group 837",
  transform: "translate(8.792 1.209)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_2449",
  "data-name": "Path 2449",
  d: "M683.637,504.474l-3.413-3.413a.118.118,0,0,1,0-.166l1.18-1.18a.117.117,0,0,1,.165,0l3.413,3.413a.118.118,0,0,1,0,.166l-1.18,1.18A.116.116,0,0,1,683.637,504.474Zm-3.165-3.5,3.248,3.247,1.014-1.014-3.247-3.248Z",
  transform: "translate(-680.189 -499.681)",
  fill: "#173a6d",
  stroke: "#173a6d",
  strokeWidth: 0.3
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_838",
  "data-name": "Group 838",
  transform: "translate(3.194 4.068)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_2450",
  "data-name": "Path 2450",
  d: "M663.612,516.1l-1.18-1.18a.118.118,0,0,1,0-.166l6.152-6.152a.117.117,0,0,1,.166,0l1.18,1.18a.117.117,0,0,1,0,.166l-6.152,6.152A.118.118,0,0,1,663.612,516.1Zm-.931-1.263,1.014,1.014,5.986-5.987-1.014-1.014Z",
  transform: "translate(-662.398 -508.565)",
  fill: "#173a6d",
  stroke: "#173a6d",
  strokeWidth: 0.3
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_839",
  "data-name": "Group 839",
  transform: "translate(0 9.207)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_2451",
  "data-name": "Path 2451",
  d: "M652.379,530.691a.119.119,0,0,1-.028-.124l1.973-5.555a.119.119,0,0,1,.2-.044l3.413,3.413a.118.118,0,0,1,.032.108.119.119,0,0,1-.073.087l-5.386,2.142a.12.12,0,0,1-.127-.025Zm2.107-5.422-1.822,5.129,4.974-1.978Z",
  transform: "translate(-652.344 -524.933)",
  fill: "#173a6d",
  stroke: "#173a6d",
  strokeWidth: 0.3
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_840",
  "data-name": "Group 840",
  transform: "translate(0.199 13.53)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_2452",
  "data-name": "Path 2452",
  d: "M653.418,538.99l-.429,1.339,1.3-.469Z",
  transform: "translate(-652.99 -538.99)",
  fill: "#173a6d",
  stroke: "#173a6d",
  strokeWidth: 0.3
}))))));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconEdit, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon_edit.5418b1ab.svg";
export { ForwardRef as ReactComponent };